
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class ModalConfirmDelete extends Vue {
  /* VUEX */

  /* ACTION */

  /* STATE */

  /* PROPS */
  @Prop({ default: false })
  private isShow: boolean;
  @Prop({ default: "" })
  private title: string;
  @Prop({ default: "" })
  private message: string;
  @Prop({ default: () => {} })
  private onDelete: Function;

  /* INITIALIZATION */

  /* METHODS */
}
